module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Foamcore.2d106459.jpg";